import React, { lazy } from "react";

import {
  VIEW_ACCOUNTS_PERMISSION,
  VIEW_PANEL_UPGRADE_PACKAGES,
} from "constants/permissions";

const PackageAssignPage = lazy(() => import("./PackageAssignPage"));

const packageAssignRoute = {
  path: "packages.package",
  element: <PackageAssignPage />,
  root: false,
  permission: [VIEW_PANEL_UPGRADE_PACKAGES, VIEW_ACCOUNTS_PERMISSION],
};

export default packageAssignRoute;
